<template>
  <div class="cube-1">
    <template v-if="!canEdit">
      <div class="cube-1-content">
        <el-row :gutter="10">
          <template v-if="cptData.data[0] && cptData.data[0].componentData.textContent">
            <div v-html="cptData.data[0].componentData.textContent" :height="300"></div>
          </template>
        </el-row>
      </div>
    </template>
    <template v-else>
      <div class="cube-1-edit">
        <p class="c-e-header">内容组件-文本组件</p>
        <div class="cube-content" v-for="(classifyData, i) in cptData.data" :key="'cube-1' + i">
          <el-form
            ref="form"
            :rules="rules"
            :model="classifyData"
            class="vendorFrom"
            label-position="right"
            label-width="100px"
          >
            <el-form-item label="状态">
              <el-switch v-model="classifyData.hide" :active-value="false" :inactive-value="true"></el-switch>
            </el-form-item>
            <el-form-item prop="textContent" label="文本内容">
              <!-- <bm-tinymce v-model="classifyData.componentData.textContent" :height="300"></bm-tinymce> -->
              <bm-tinymce
                ref="textContent"
                id="textContent"
                v-model="classifyData.componentData.textContent"
                @input="updateCache({ key: 'textContent', value: $event })"
                :height="300"
                :xiumi="true"
              ></bm-tinymce>
            </el-form-item>
            <el-form-item v-loading="loading">
              <el-button type="primary" @click="save(i)">保存</el-button>
              <!-- <el-button type="danger" @click="remove(i)">删除</el-button> -->
              <!-- <el-button type="info" @click="reset(i)">重置</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'text_content',
  inject: ['addidtocomponent', 'savaTinyPage'],
  props: {
    cptData: {
      type: Object,
      default: {
        componentName: 'classify',
        selectStatus: false,
        data: [
          {
            hide: 0
          }
        ]
      },
      require: true
    },
    canEdit: {
      type: Boolean,
      default: false,
      require: false,
      comment: '是否编辑状态， true是，会在装修页面右侧调用'
    }
  },
  data() {
    return {
      loading: false,
      defaultImg: require('@/asset/logo.png'),
      areaId: this.$store.getters['malls/getCurrentEditAreaId'],
      rules: {
        textContent: [{
          required: true, trigger: 'blur', validator: (rule, value, callback) => {
            for (let i of this.cptData.data) {
              if (!i.componentData.textContent) {
                return callback(new Error('选添加文本组件内容!'))
              }
            }
            callback()
          }
        }],
      },
      model: {
        id: '',
        componentType: 'TEXT',
        componentName: '',
        componentData: { textContent: '' },
        hide: 0,
      }
    }
  },
  created() {
    if (!this.cptData.data.length) {
      this.cptData.data.push({ ...this.model })
    }
  },
  methods: {
    ...mapMutations('product/partner', ['updateCache']),
    initRadio(i) {
      if (this.cptData.data[0].imgNode[i].type == 1) {
        this.cptData.data[0].imgNode[i].target = ''
      }
    },
    save() {
      this.$refs['form'][0].validate(valid => {
        if (valid) {
          let tag = ''
          if (!this.cptData.data[0].id) {
            tag = 'postMagicCube'
          } else {
            tag = 'putMagicCube'
          }
          this.loading = true
          console.log("============>",this.cptData.data[0])
          Promise.resolve()
            .then(() => {
              if (tag === 'postMagicCube') {
                return this.$http.post('boom-center-admin-service/sysAdmin/decorationMagicCube', this.cptData.data[0], {
                  headers: {
                    ['Bm-Area-Id']: this.areaId
                  }
                })
              }
              if (tag === 'putMagicCube') {
                return this.$http.put(`boom-center-admin-service/sysAdmin/micro/page/${this.cptData.data[0].id}`, this.cptData.data[0], {
                  headers: {
                    ['Bm-Area-Id']: this.areaId
                  }
                })
              }
            })
            .then(res => {
              this.cptData.data[0] = res
              // this.addidtocomponent({
              //   id: res.id,
              //   activeStatus: res.hideStatus == 0 ? true : false
              // })
              this.savaTinyPage()
              this.$message.success('保存成功')
            })
            .catch(err => {
              this.$message.error(err)
            })
            .finally(() => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
        }
      })
    },
    async reset(i) {
      console.log("iiiiii", i, this.cptData)
      if (!this.cptData.data[0].id) {
        this.$message.info('无数据，无须删除')
        return
      }
      let res = await this.$confirm('此操作将永久删除当前编辑数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      if (res == 'confirm') {
        this.cptData.data[0] = this.model
        this.$http.put(`boom-center-admin-service/sysAdmin/micro/page/${this.cptData.data[0].id}`, this.cptData.data[0], {
          headers: {
            ['Bm-Area-Id']: this.areaId
          }
        }).then(res => {
          console.log(res)
        })
      } else {
        this.$message({
          type: 'info',
          message: '已取消重置'
        })
      }
    },
    async remove(index) {
      if (!this.cptData.data[0].id) {
        this.$message.info('无数据，无须删除')
        return
      }
      let res = await this.$confirm('此操作将永久删除当前编辑数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      if (res == 'confirm') {
        this.loading = true
        this.$http
          .delete('boom-center-admin-service/sysAdmin/decorationMagicCube/' + this.cptData.data[0].id)
          .then(() => {
            this.addidtocomponent({ id: '', activeStatus: '' })
            this.$message.success('移除成功')
          })
          .catch(err => {
            this.$message.error(err)
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false
            }, 200)
          })
      } else {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "./com.less";
.cube-1 {
  .cube-1-content {
    min-height: 78px;
    padding: 3px 5px;
    .cube-item {
      padding: 3px;
      img {
        width: 100%;
        height: 68px;
      }
    }
  }
  .cube-1-edit {
    padding: 25px;
    background-color: @color-background;
    .c-e-header {
      margin-bottom: 20px;
      font-weight: 700;
    }
    .cube-content {
      .cube-img-block {
        width: 60%;
        display: inline-block;
        .cube-img-item {
          display: inline-block;
          // width: 50%;
          position: relative;
          & > span {
            background-color: rgba(0, 0, 0, 0.1);
            position: absolute;
            .radius(6px);
            display: inline-block;
            padding: 0 5px;
            top: 0;
            left: 0;
            z-index: 10;
          }
        }
      }
    }
  }
}
/deep/ .tinymce-container{
  padding-top: 40px;
}
/deep/ .wscnph{
  max-width: 100%;
}
</style>
